// Copyright (c) 2017 Deere & Company

import React from 'react';
import SystemSelectedClaimsAccordion from './system-selected-claims-accordion';
import UserSelectedClaimsAccordion from './user-selected-claims-accordion';

const PrepareAuditMain = () =>
    <main className='prepare-audit-main'>
        <SystemSelectedClaimsAccordion/>
        <UserSelectedClaimsAccordion/>
    </main>;

PrepareAuditMain.displayName = 'PrepareAuditMain';

export default PrepareAuditMain;



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/components/prepare-audit-main.js